import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import { CallToAction } from 'components/atoms/callToAction';
import { Image } from 'components/atoms/image';
import './style.scss';

const ProductBrowserDetailsCard = props => {
  const { data, count, type } = props;
  const [isDivHovered, divHovered] = useState(false);
  const styleOfDiv = isDivHovered ? 'is-hovered-card' : 'is-not-hovered-card';
  if (!data) {
    return null;
  }
  let { detailCard, device } = data;
  const showImage = () => {
    let { hover_image, image, image_path } = detailCard.images;
    let { web } = device;
    let { thumbnail } = device;
    const imageUrl = image_path + web + '/';
    const imageThumbnailUrl = image_path + thumbnail + '/';
    const imageToShow = isDivHovered
      ? imageUrl + hover_image
      : imageUrl + image;
    const thumbnailUrl = isDivHovered
      ? imageThumbnailUrl + hover_image
      : imageThumbnailUrl + image;
    const objectFit = isDivHovered ? 'cover' : 'contain';
    return (
      <div className="product-image-card">
        <Image
          height="40vh"
          width="100%"
          objectFit={objectFit}
          src={imageToShow}
          alt="Image failed"
          className="product-img"
          thumbNail={thumbnailUrl}
          isHoveredImagePresent={true}
          id={detailCard.url_slug}
        />
      </div>
    );
  };

  const onProductCardClick = (url_slug, id) => {
    // TODO:
    const locationPath = props.location;
    if(type === "Workations") {
      RouteUtil.setRouteChange(
        props,
        `/workcations/product/${url_slug}`,
        locationPath.hash,
        locationPath.pathname,
        id,
        id
      );
    } else {
      RouteUtil.setRouteChange(
        props,
        `/homes/${url_slug}`,
        locationPath.hash,
        locationPath.pathname,
        id,
        id
      );
    }
    if (props.match.params.productSlug) {
      if (props.match.params.productSlug !== url_slug) {
        window.location.reload();
      }
    }
  };

  const showImageData = () => {
    let {
      bathrooms,
      bedrooms,
      content,
      max_area,
      min_area,
      productName,
      productVersion,
    } = detailCard;

    return (
      <div className="project-card align-items-end">
        <Row className="project-detail">
          <Col md={{ span: 7 }}>
            <div className={type=="Workations"? "product-name workation-counter" : "product-name medium-counter"}>
              {productName}
              <span className="product-version">{productVersion}</span>
            </div>
          </Col>
          <Col className="align-items-end project-content" md={{ span: 5 }}>
            {/*<h3>*/}
            {/*  {content.length > 13 ? content.slice(0, 13) + '...' : content}*/}
            {/*</h3>*/}
          </Col>
        </Row>

        <Row className="area-detail">
          {!max_area && !min_area ? (
            <></>
          ) : (
            renderProductArea(max_area, min_area)
          )}
          {type !== "Workations" && (
            <>
              <Col md={{ span: 3 }}>
                <Row>
                  <span>BEDROOMS</span>
                </Row>
                <Row>
                  <h2>{bedrooms}</h2>
                </Row>
              </Col>
              <Col md={{ span: 2 }}>
                <Row>
                  <span>BATH</span>
                </Row>
                <Row>
                  <h2>{bathrooms}</h2>
                </Row>
              </Col>
            </>
          )}
        </Row>

        <div className="explore-button">
          <CallToAction
            text={'Explore'}
            mode={'transparent'}
            type={'link'}
            size={'small'}
          />
        </div>
      </div>
    );
  };

  const renderProductArea = (max_area, min_area) => {
    let display_area =
      min_area && !max_area
        ? min_area
        : max_area && !min_area
        ? max_area
        : `${min_area} - ${max_area}`;
    return (
      <Col md={{ span: 7 }}>
        <Row>
          <span>SQ.FEET</span>
        </Row>
        <Row>
          <h2>{display_area}</h2>
        </Row>
      </Col>
    );
  };

  return (
    <div
      className="detail-card"
      onMouseLeave={() => divHovered(false)}
      onMouseEnter={() => divHovered(true)}
      onClick={() =>
        onProductCardClick(data.detailCard.url_slug, data.detailCard.id)
      }
    >
      <div className="align-card">
        <div className={styleOfDiv}>{showImage()}</div>
      </div>
      {showImageData()}
    </div>
  );
};

export default withRouter(ProductBrowserDetailsCard);
